import { Stack, Box } from '@mui/material';
import { Tooltip, Typography, colors } from '@sweep-io/sweep-design';
import { MoreActionsVertical, Pin } from '@sweep-io/sweep-design/dist/icons';
import { PromptGroup } from '@server/prompts';
import { PromptLibraryIcon } from '../PromptLibraryIcon';
import { useState } from 'react';
import { ActionsMenu } from '../../../common/actions-menu/ActionsMenu';
import { CategoryMenuAction, getCategoryMenuActions } from './utils';


interface CategoryListItemProps {
  category: PromptGroup;
  isSelected: boolean;
  onClick: () => void;
  onMenuAction?: (action: CategoryMenuAction) => void;
}

export const CategoryListItem = ({
  category,
  isSelected,
  onClick,
  onMenuAction,
}: CategoryListItemProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const promptCount = category.prompts?.length ?? 0;



  return (
    <Box
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '40px',
        padding: '8px 12px 8px 8px',
        borderRadius: '8px',
        cursor: 'pointer',
        backgroundColor: isSelected
          ? colors.blue[100]
          : isHovered
            ? colors.grey[100]
            : 'transparent',
        '&:hover': {
          backgroundColor: isSelected ? colors.blue[100] : colors.grey[100],
          padding: '8px 4px 8px 8px',
        },
      }}
    >
      <Stack direction="row" gap={1} alignItems="center">
        <PromptLibraryIcon
          icon={category.iconName}
          color={isSelected ? colors.blue[500] : undefined}
        />
        <Typography
          variant="body"
          color={isSelected ? colors.blue[500] : colors.grey[800]}
          ellipsis
        >
          {category.name}
        </Typography>
      </Stack>

      <Stack direction="row" gap={0.5} alignItems="center">
        {category.isPinned && (
          <Tooltip title="Unpin">
            <Box
              component="span"
              onClick={(e) => {
                e.stopPropagation();
                onMenuAction?.('pin');
              }}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Pin color={colors.blue[500]} size="small" />
            </Box>
          </Tooltip>
        )}
        {isHovered && onMenuAction ? (
          <Box onClick={(e) => e.stopPropagation()}>
            <ActionsMenu
              actions={getCategoryMenuActions(category.isPinned)}
              onClick={(action) => onMenuAction(action.value)}
              MenuButtonIcon={<MoreActionsVertical />}
              iconSize="tiny"
              menuPlacement="bottom"
              menuWidth="240px"
            />
          </Box>
        ) : (
          <Stack pl={1}>
            <Typography variant="caption" color={isSelected ? colors.blue[500] : colors.grey[700]}>
              {promptCount}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Box>
  );
};
